<template>
  <transition-group
    class="alerts"
    name="list"
    tag="ul"
  >
    <li
      v-for="alert in alerts"
      :key="alert.id"
      :class="'alert alert-' + alert.alertType"
      @click="dismissAlert(alert.id)"
    >
      {{ alert.message }}
      <button
        :id="'alert-dismiss-' + alert.id"
        class="alert-dismiss"
        type="button"
      >
        <icon name="fas fa-times" />
      </button>
    </li>
  </transition-group>
</template>

<script>
import { dom, library } from '@fortawesome/fontawesome-svg-core';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import Icon from './Icon.vue';

library.add(faTimes);

dom.i2svg();
dom.watch();

export default {
  name: 'Alert',
  components: {
    Icon,
  },
  props: {
    alerts: {
      type: Array,
      required: true,
    },
  },
  emits: ['dismiss'],
  methods: {
    dismissAlert(id) {
      this.$emit('dismiss', id);
    },
  },
};
</script>

<style scoped>
@reference "tailwindcss";

/**
 * Alerts sit on the bottom edge of the viewport. The stack is what is pinned
 * there, so that two alerts at once sit above one another instead of landing
 * on the same strip, where the older one is unreadable and unclickable.
 */
.alerts {
  @apply fixed inset-x-0 bottom-0 list-none m-0 p-0;
  z-index: 55;
}

/**
 * Alerts carry their own fills rather than theme surfaces, because an alert
 * should read as an interruption; the fills are the ones set in alerts.css.
 */
.alert {
  @apply relative w-full p-4 pr-12 text-center text-lg;
  background-color: var(--surface-card);
  border-top: 1px solid var(--border);
  color: var(--text);
  cursor: pointer;
}

.alert-success {
  background-color: var(--confirm);
  border-top-color: var(--confirm);
  color: var(--on-action);
}

.alert-error {
  background-color: var(--danger);
  border-top-color: var(--danger);
  color: var(--on-action);
}

.alert-warning {
  background-color: var(--state-soon);
  border-top-color: var(--state-soon);
  color: #1F1707;
}

/**
 * The dismiss control was a 20px circle with 8px of its own margin, which
 * left a tap target well under the 44px a thumb needs.
 */
.alert-dismiss {
  @apply absolute right-0 flex items-center justify-center rounded-full font-bold;
  background: rgba(0, 0, 0, 0.18);
  color: inherit;
  height: 2.25rem;
  margin: auto 1rem;
  top: 0;
  bottom: 0;
  width: 2.25rem;

  &:hover, &:active {
    background: rgba(0, 0, 0, 0.32);
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid currentColor;
    outline-offset: 2px;
  }
}
</style>
